import { clsx } from "@trydig/ui";
import type { PropsWithChildren } from "react";
import styles from "./InlineContent.module.css";

export const InlineContent = ({
	children,
	columnOnMobile = false,
}: PropsWithChildren<{ columnOnMobile?: boolean }>) => {
	return (
		<div
			className={clsx(styles["product-card__inline"], columnOnMobile && styles["direction-column"])}
		>
			{children}
		</div>
	);
};
